import { PicSearchMode } from '@containers/Consignments/components/fragments/__generated__/PICSearch2Query.graphql';
import { KeyValuePair, PicSearchData, PicTypeRuleAirtable } from '@typings';
import Airtable from 'airtable';

import { convertPicTypeStringsToKeyValuePairs } from './pic-search-utils';

export const mapRuleRecord = (record: Airtable.Record<any>): PicTypeRuleAirtable | null => {
    const ruleId = record.get('Rule ID') as number;
    if (!ruleId) return null;

    return {
        ruleId,
        message: record.get('Message') as string,
        messageType: record.get('Message Type') as PicTypeRuleAirtable['messageType'],
        ruleEnabledFor: record.get('RuleEnabledFor') as PicSearchMode[],
    };
};

export const mapStateConfigRecord = (
    record: Airtable.Record<any>,
    rulesMap: Map<string, PicTypeRuleAirtable>
): PicSearchData => {
    const rawPicTypes = (record.get('ApplicablePicTypes') as string[]) ?? [];
    const convertedPicTypes: KeyValuePair[] = convertPicTypeStringsToKeyValuePairs(rawPicTypes);

    const rules = ((record.get('Custom Rules') as string[]) ?? [])
        .map((linkedId) => rulesMap.get(linkedId) ?? null)
        .filter((rule): rule is PicTypeRuleAirtable => !!rule);

    return {
        state: record.get('State') as string,
        active: record.get('Active') as boolean,
        priority: record.get('Priority') as number,
        applicablePicTypes: convertedPicTypes,
        rules,
    };
};
